export default {
    // Common translations
    driverPerformanceFunctionTab_common_save: 'Guardar',
    driverPerformanceFunctionTab_common_success: 'Éxito',
    driverPerformanceFunctionTab_common_error: 'Error',
    driverPerformanceFunctionTab_common_warning: 'Advertencia',
};